import { render, staticRenderFns } from "./Records.vue?vue&type=template&id=7fcb7706&scoped=true"
import script from "./Records.vue?vue&type=script&lang=js"
export * from "./Records.vue?vue&type=script&lang=js"
import style0 from "./Records.vue?vue&type=style&index=0&id=7fcb7706&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fcb7706",
  null
  
)

export default component.exports